import QuestionAttachments from './QuestionAttachments';

export default QuestionAttachments;
